"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/journeyController',["require", "exports", "providers/ajaxSettingsProvider", "controllers/abortingRequest"], function (require, exports, ajaxSettingsProvider, abortingRequest) {
    "use strict";

    var JourneyController = function () {
        function JourneyController() {
            _classCallCheck(this, JourneyController);
        }

        _createClass(JourneyController, [{
            key: "checkRebuildStatus",
            value: function checkRebuildStatus(data) {
                return abortingRequest.send('/api/Journey/CheckRebuildStatus', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchSingleJourneyHeader",
            value: function fetchSingleJourneyHeader(data) {
                return abortingRequest.send('/api/Journey/FetchSingleJourneyHeader', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchJourneyHeaders",
            value: function fetchJourneyHeaders(data) {
                return abortingRequest.send('/api/Journey/FetchJourneyHeaders', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchJourneyHeadersBetweenDates",
            value: function fetchJourneyHeadersBetweenDates(data) {
                return abortingRequest.send('/api/Journey/FetchJourneyHeadersBetweenDates', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchDayJourneyForJourneyId",
            value: function fetchDayJourneyForJourneyId(data) {
                return abortingRequest.send('/api/Journey/FetchDayJourneyForJourneyId', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchMoreJourneyHeaders",
            value: function fetchMoreJourneyHeaders(data) {
                return abortingRequest.send('/api/Journey/FetchMoreJourneyHeaders', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchVersion1Journey",
            value: function fetchVersion1Journey(data) {
                return abortingRequest.send('/api/Journey/FetchVersion1Journey', ajaxSettingsProvider.httpPost(data), true);
            }
        }, {
            key: "fetchLayers",
            value: function fetchLayers(data) {
                return abortingRequest.send('/api/Journey/FetchLayers', ajaxSettingsProvider.httpPost(data), true);
            }
        }, {
            key: "cloneJourney",
            value: function cloneJourney(data) {
                return abortingRequest.send('/api/Journey/CloneJourney', ajaxSettingsProvider.httpPost(data), true);
            }
        }, {
            key: "checkIfLinkIsBlacklisted",
            value: function checkIfLinkIsBlacklisted(data) {
                return abortingRequest.send('/api/Journey/CheckIfLinkIsBlacklisted', ajaxSettingsProvider.httpPost(data), true);
            }
        }, {
            key: "fetchHomelatLng",
            value: function fetchHomelatLng(data) {
                return abortingRequest.send('/api/Journey/FetchHomelatLng', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "checkSpeedChallenges",
            value: function checkSpeedChallenges(data) {
                return abortingRequest.send('/api/Journey/CheckSpeedChallenges', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "deleteVersion3Journey",
            value: function deleteVersion3Journey(data) {
                return abortingRequest.send('/api/Journey/DeleteVersion3Journey', ajaxSettingsProvider.httpPost(data, 300000));
            }
        }, {
            key: "undeleteVersion3Journey",
            value: function undeleteVersion3Journey(data) {
                return abortingRequest.send('/api/Journey/UndeleteVersion3Journey', ajaxSettingsProvider.httpPost(data, 300000));
            }
        }, {
            key: "requestJourneyClean",
            value: function requestJourneyClean(data) {
                return abortingRequest.send("/api/Journey/RequestJourneyClean", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "requestScoreRebuild",
            value: function requestScoreRebuild(data) {
                return abortingRequest.send("/api/Journey/RequestScoreRebuild", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getJourneyMileageSummary",
            value: function getJourneyMileageSummary(data) {
                return abortingRequest.send("/api/Journey/GetJourneyMileageSummary", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "cleanBetweenDates",
            value: function cleanBetweenDates(data) {
                return abortingRequest.send("/api/Journey/CleanBetweenDates", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "deletePolicyJourney",
            value: function deletePolicyJourney(data) {
                return abortingRequest.send('/api/Journey/DeletePolicyJourney', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "restorePolicyJourney",
            value: function restorePolicyJourney(data) {
                return abortingRequest.send('/api/Journey/RestorePolicyJourney', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "sendRebuildFromDateRequest",
            value: function sendRebuildFromDateRequest(data) {
                return abortingRequest.send('/api/Journey/SendRebuildAllJourneysFromDateRequest', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "rebuildDevelopmentLayerJourney",
            value: function rebuildDevelopmentLayerJourney(data) {
                return abortingRequest.send('/api/Journey/RebuildDevelopmentLayerJourney', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getLinkInfo",
            value: function getLinkInfo(data) {
                return abortingRequest.send('/api/Journey/GetLinkInfo', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getMatchRoute",
            value: function getMatchRoute(data) {
                return abortingRequest.send('/api/Journey/GetMatchedRoute', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getJourneyStats",
            value: function getJourneyStats(environment, policyId) {
                return abortingRequest.send('/api/Journey/GetJourneyStats/' + environment + '/' + policyId, ajaxSettingsProvider.httpGet());
            }
        }, {
            key: "getJourneySummaryForDate",
            value: function getJourneySummaryForDate(data) {
                return abortingRequest.send('/api/Journey/GetJourneySummariesForDate', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getVehicleLocation",
            value: function getVehicleLocation(data) {
                return abortingRequest.send("/api/Journey/GetVehicleLocation", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getRealTimeAssistanceRequests",
            value: function getRealTimeAssistanceRequests(data) {
                return abortingRequest.send("/api/Journey/GetRealTimeAssistanceRequests", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "getRealTimeImpacts",
            value: function getRealTimeImpacts(data) {
                return abortingRequest.send("/api/Journey/GetRealTimeImpacts", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "rebuildJourney",
            value: function rebuildJourney(data) {
                return abortingRequest.send("/api/Journey/RebuildJourney", ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "journeyViewed",
            value: function journeyViewed(data) {
                return abortingRequest.send("/api/Journey/JourneyViewed", ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return JourneyController;
    }();

    return new JourneyController();
});
//# sourceMappingURL=journeyController.js.map;
